import React, { useState } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { Nav } from "react-bootstrap"
import { useAuth } from "@src/context"

import { filterRecord } from "@helpers/GlobalFunctions"

const MobileHeader = ({ routes, handleClose = null, hasProfile = true }) => {
    const profileMenu = routes.find(menu => menu.isProfileMenu);
    const myConnectionsMenu = profileMenu?.children?.find(child => child.text === 'My Connections');
    const settingsMenu = profileMenu?.children?.find(child => child.text === 'Settings');

    return (
        <React.Fragment>
            <Nav className="flex-column">
                {routes.map((menu, index) => {
                    const dept = 1

                    let menuName = `sidebar-menu-${dept}-${index}`
                    if (menu.link) {
                        menuName = `sidebar-menu-${menu.link.replace(
                            /\//g,
                            ""
                        )}`
                    }

                    if (menu && !menu.hidden) {
                        // Skip profile menu in mobile sidebar - Settings and My Connections will be shown separately
                        if (menu.isProfileMenu) {
                            return null;
                        }
                        return (
                            <ListMenu
                                dept={dept}
                                data={menu}
                                hasSubMenu={menu.children}
                                menuName={menuName}
                                key={menuName}
                                menuIndex={index}
                                handleClose={handleClose}
                                hasProfile={hasProfile}
                            />
                        )
                    } else {
                        return null
                    }
                })}
                {/* Add My Connections link from profile menu */}
                {myConnectionsMenu && (
                    <ListMenu
                        dept={1}
                        data={myConnectionsMenu}
                        hasSubMenu={myConnectionsMenu.children}
                        menuName="sidebar-menu-my-connections"
                        menuIndex={routes.length}
                        handleClose={handleClose}
                        hasProfile={hasProfile}
                    />
                )}
                {/* Add Settings menu from profile menu */}
                {settingsMenu && (
                    <ListMenu
                        dept={1}
                        data={settingsMenu}
                        hasSubMenu={settingsMenu.children}
                        menuName="sidebar-menu-settings"
                        menuIndex={routes.length + 1}
                        handleClose={handleClose}
                        hasProfile={hasProfile}
                    />
                )}
            </Nav>
        </React.Fragment>
    )
}

const ListMenu = ({
    dept,
    data,
    hasSubMenu,
    menuName,
    menuIndex,
    handleClose,
    hasProfile = true,
}) => {
    const { pathname } = useLocation()
    const { LoginData } = useAuth()
    const [activeMenus, setActiveMenus] = useState([])
    
    const profilePath = LoginData?.role === "candidate" ? "/candidate-profile" : "/employer-profile";
    const isAllowedRoute = data.link === "/logout" || data.link === profilePath;
    const isDisabled = !hasProfile && data.link && !isAllowedRoute;

    const handleArrowClick = (menuName) => {
        let newActiveMenus = [...activeMenus]

        if (newActiveMenus.includes(menuName)) {
            var index = newActiveMenus.indexOf(menuName)
            if (index > -1) {
                newActiveMenus.splice(index, 1)
            }
        } else {
            newActiveMenus.push(menuName)
        }

        setActiveMenus(newActiveMenus)
    }

    let isToggle = activeMenus.includes(menuName)
    if (hasSubMenu && !isToggle) {

        if(filterRecord(data.children, "link", pathname)) {
            handleArrowClick(menuName)
            isToggle = true
        }
    }

    return (
        <React.Fragment>
            {hasSubMenu ? (
                <Nav.Item
                    onClick={() => handleArrowClick(menuName)}
                    className={`my-3 position-relative mobile-nav-link mobile-nav-dropdown ${
                        isToggle ? "toggled" : ""
                    }`}
                >
                    <span className="text-truncate">{data.text}</span>
                </Nav.Item>
            ) : (
                <Nav.Link
                    as={isDisabled ? "span" : NavLink}
                    to={isDisabled ? undefined : data.link}
                    className={`my-3 mobile-nav-link ${isDisabled ? "disabled" : ""} ${data.isLogout ? "logout-link" : ""}`}
                    onClick={isDisabled ? (e) => {
                        e.preventDefault();
                        if (handleClose) handleClose();
                    } : handleClose}
                    style={isDisabled ? { cursor: "not-allowed", opacity: 0.5 } : (data.isLogout ? { color: "#dc3545", fontWeight: 500 } : {})}
                >
                    {data.text}
                </Nav.Link>
            )}
            {hasSubMenu && (
                <SubMenu
                    dept={dept}
                    data={data.children}
                    toggle={isToggle}
                    menuIndex={menuIndex}
                    hasProfile={hasProfile}
                />
            )}
        </React.Fragment>
    )
}

const SubMenu = ({ dept, data, toggle, menuIndex, hasProfile = true }) => {
    if (!toggle) {
        return null
    }

    dept = dept + 1

    // Separate logout from other menu items
    const regularMenus = data.filter(menu => !menu.isLogout);
    const logoutMenu = data.find(menu => menu.isLogout);

    return (
        <Nav className="flex-column">
            {regularMenus.map((menu, index) => {
                let menuName = `sidebar-submenu-${dept}-${menuIndex}-${index}`
                if (menu.link) {
                    menuName = `sidebar-submenu-${menu.link.replace(/\//g, "")}`
                }

                return (
                    <ListMenu
                        dept={dept}
                        data={menu}
                        hasSubMenu={menu.children}
                        menuName={menuName}
                        key={menuName}
                        menuIndex={index}
                        hasProfile={hasProfile}
                    />
                )
            })}
            {logoutMenu && (
                <>
                    <div className="border-top my-2"></div>
                    <ListMenu
                        dept={dept}
                        data={logoutMenu}
                        hasSubMenu={logoutMenu.children}
                        menuName={`sidebar-submenu-${dept}-${menuIndex}-logout`}
                        menuIndex={regularMenus.length}
                        hasProfile={hasProfile}
                    />
                </>
            )}
        </Nav>
    )
}

export default MobileHeader
